import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import customStyle from '../../Assets/CSS/stylesheet_UHS';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import axios from 'axios';
import { IconButton, makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import moment from "moment";
import { Grid, CircularProgress } from '@material-ui/core';
import { Modal } from "react-bootstrap";
import Tooltip from "@material-ui/core/Tooltip";
import './readExcel.css'

const CustomButton = withStyles(
    customStyle.viewBtn
)(Button);

const CustomTooltip = withStyles({
    tooltip: {
        fontSize: 14,
    },
})(Tooltip);

const Notes = ({ memberId, detailsData, data, agentId, setLoader, isMaximized }) => {
    const notesEndRef = useRef(null);
    const notesContainerRef = useRef(null);
    const classes = useStyles();
    const [noteInput, setNoteInput] = useState('');
    const [noteError, setNoteError] = useState("");
    const [notes, setNotes] = useState([]);
    const [notesError, setNotesError] = useState("");
    const [hoveredNoteIndex, setHoveredNoteIndex] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [confirmNote, setConfirmNote] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);
    const [savingLoader, setSavingLoader] = useState(false);
    const [editModal, setEditModal] = useState(null);
    const [successModal, setSuccessModal] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    const [expandedNotes, setExpandedNotes] = useState({});
    const [charLength, setCharLength] = useState(350);
    const [deleteIndex, setDeleteIndex] = useState(null);

    useEffect(() => {
        setLoader(true);
        getNotes(memberId);
        scrollToBottom();
    }, [memberId]);

    useEffect(() => {
        setCharLength(isMaximized ? 550 : 350);
        scrollToBottom();
        window.handleToggleExpand = (i) => {
            setExpandedNotes((prevState) => ({
                ...prevState,
                [i]: !prevState[i]
            }));
        };
        return () => {
            delete window.handleToggleExpand;
        };
    }, [isMaximized]);

    const toggleExpand = (index) => {
        setExpandedNotes((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        let errorMessage = "";

        // if (value.length >= 125) {
        //     errorMessage = "Maximum 125 characters allowed.";
        // }

        setNoteInput(value);
        setNoteError(errorMessage);
    };

    const scrollToBottom = () => {
        if (notesContainerRef.current) {
            notesContainerRef.current.scrollTop = notesContainerRef.current.scrollHeight;
        }
    }

    const getNotes = (memberIdSource) => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/enrollment/member-notes/${memberIdSource}`)
            .then(res => {
                setLoader(false);
                if (res.data.response) {
                    setNotes(res.data.response);
                    setNotesError("");
                    scrollToBottom();
                } else {
                    setNotesError(res.data.message);
                    setNotes([]);
                    scrollToBottom();
                }
            })
    }

    const handleSaveNote = () => {
        setLoader(true);
        setSavingLoader(true);
        if (noteInput.trim() === '') return;
        let noteToEdit;
        if (editingIndex !== null && editingIndex !== undefined) {
            if (notes.length <= editingIndex) {
                noteToEdit = notes[editingIndex - 1];
            } else {
                noteToEdit = notes[editingIndex];
            }

            const updatedNote = {
                subId: noteToEdit.subId,
                source: noteToEdit.source,
                note: noteInput,
                id: noteToEdit.id,
            };

            axios.put(`${process.env.REACT_APP_BASE_URL}/enrollment/update-member-note`, updatedNote)
                .then(res => {
                    if (res.data.code == 200) {
                        getNotes(detailsData.id);
                        setNoteInput("");
                        setNoteError("");
                        setEditingIndex(null);
                        scrollToBottom();
                        setLoader(false);
                        setSavingLoader(false);
                        setErrMsg("Note edited successfully.");
                        setSuccessModal(true);
                    } else {
                        setLoader(false);
                        setSavingLoader(false);
                        setErrMsg("Failed to edit note.");
                        setSuccessModal(true);
                    }
                });
        } else {
            const newNote = {
                note: noteInput,
                source: detailsData.id,
                brokerId: agentId,
                subId: data[0].subId
            };

            axios.post(`${process.env.REACT_APP_BASE_URL}/enrollment/create-member-note`, newNote)
                .then(res => {
                    if (res.data.code == 200) {
                        getNotes(detailsData.id);
                        setNoteInput("");
                        setNoteError("");
                        scrollToBottom();
                        setLoader(false);
                        setSavingLoader(false);
                        setErrMsg("Note added successfully.");
                        setSuccessModal(true);
                    } else {
                        setLoader(false);
                        setSavingLoader(false);
                        setErrMsg("Failed to add note.");
                        setSuccessModal(true);
                    }
                });
        }
    };

    const handleEditNote = (note, index) => {
        const noteToEdit = notes[index];

        if (editingIndex !== null && editingIndex !== index) {
            setEditModal({ index, note: noteToEdit.note });
        }
        else if (noteInput.trim() !== '' && editingIndex === null) {
            setEditModal({ index, note: noteToEdit.note });
        }
        else {
            setNoteInput(noteToEdit.note);
            setEditingIndex(index);
        }
    };

    const handleDeleteNote = (note, index) => {
        setDeleteModal(true);
        setConfirmNote(note);
        setDeleteIndex(index);
    };

    const confirmDelete = (note, index) => {
        setLoader(true);
        setDeleteModal(false);
        const newNote = {
            subId: note.subId,
            source: note.source,
            id: note.id
        }
        axios.put(`${process.env.REACT_APP_BASE_URL}/enrollment/delete-member-note`, newNote)
            .then(res => {
                if (res.data.code == 200) {
                    getNotes(detailsData.id);
                    setNoteError("");
                    scrollToBottom();
                    setLoader(false);
                    setSuccessModal(true);
                    setErrMsg("Note deleted successfully.");
                    setDeleteIndex(null);
                } else {
                    setLoader(false);
                    setSuccessModal(true);
                    setErrMsg("Failed to delete note.");
                    setDeleteIndex(null);
                }
            })
    };

    const formatDateTime = (isoString) => {
        const momentObj = moment(isoString);

        const formattedDate = momentObj.format("D MMM, YYYY");
        const formattedTime = momentObj.format("h:mm A");

        return { date: formattedDate, time: formattedTime };
    };

    const cancelUpdate = () => {
        setNoteInput("");
        setEditingIndex(null);
    }

    const cancelDelete = () => {
        setDeleteModal(false);
        setDeleteIndex(null);
    }

    const confirmEdit = () => {
        let edit = editModal;
        if (edit) {
            setNoteInput(edit.note);
            setEditingIndex(edit.index);
            setEditModal(null);
        }
    }

    return (
        <Grid item sm={12} xs={12} md={12} lg={12} style={{ fontFamily: "Roboto, Arial, Helvetica, sans-serif", height: "100%" }}>
            <div
                style={{
                    border: "1px solid #abadd3",
                    // borderRadius: "8px",
                    padding: "16px",
                    backgroundColor: "#e4effc",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div
                    ref={notesContainerRef}
                    style={{
                        flexGrow: 1,
                        overflowY: "auto",
                        marginBottom: "16px",
                        paddingRight: "8px",
                    }}
                >
                    {notesError != "" ? (
                        <p style={{ color: "#777" }}>{notesError}</p>
                    ) : (
                        <ul style={{ listStyle: "none", padding: 0 }}>
                            {notes?.map((note, index) => (
                                <li
                                    key={index}
                                    onMouseEnter={() => setHoveredNoteIndex(index)}
                                    onMouseLeave={() => setHoveredNoteIndex(null)}
                                    style={{
                                        marginBottom: "12px",
                                        padding: "12px 12px 9px 15px",
                                        borderRadius: 10,
                                        border: "solid 1px #abadd3",
                                        backgroundColor: (editingIndex == index || deleteIndex === index) ? "#fff" : "#f6f9ff",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            marginBottom: "4px",
                                            maxWidth: "93%",
                                            textAlign: "justify",
                                            overflowWrap: "anywhere",
                                        }}
                                    >
                                        <div
                                            className={!expandedNotes[index] ? "clamp-3" : ""}
                                            style={{ whiteSpace: "pre-wrap" }}
                                            dangerouslySetInnerHTML={{ __html: note.note.replace(/\n/g, "<br />") }}
                                        />
                                        <span
                                            style={{
                                                color: "#2f3192",
                                                cursor: "pointer",
                                                fontSize: "13px",
                                                fontWeight: "bold",
                                                display: "inline-block",
                                                marginTop: 6,
                                                visibility: note.note.length > charLength ? "visible" : "hidden",
                                            }}
                                            onClick={() => toggleExpand(index)}
                                        >
                                            {expandedNotes[index] ? "Read less" : "Read more"}
                                        </span>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: "-webkit-fill-available", height: "-webkit-fill-available" }}>
                                        <div style={{ fontSize: "12px", color: "#999", textAlign: "end" }}>
                                            <div>{formatDateTime(note.updatedTime).date}</div>
                                            <div>{formatDateTime(note.updatedTime).time}</div>
                                        </div>
                                        <div style={{
                                            // position: "absolute",
                                            visibility: (hoveredNoteIndex === index || editingIndex === index || deleteIndex === index) ? "visible" : "hidden",
                                            top: "8px",
                                            right: "8px",
                                            display: "flex",
                                            gap: "8px",
                                            justifyContent: "flex-end",
                                        }}>
                                            <span
                                                style={{ cursor: "pointer", color: "#2f3192" }}
                                                onClick={() => handleEditNote(note, index)}
                                            >
                                                <CustomTooltip
                                                    title="Edit"
                                                    placement="bottom"
                                                >
                                                    <EditIcon style={{ height: 21, width: 21 }} />
                                                </CustomTooltip>
                                            </span>
                                            <span
                                                style={{ cursor: "pointer", color: "#dc3545" }}
                                                onClick={() => handleDeleteNote(note, index)}
                                            >
                                                <CustomTooltip
                                                    title="Delete"
                                                    placement="bottom"
                                                >
                                                    <DeleteOutlineIcon style={{ height: 21, width: 21 }} />
                                                </CustomTooltip>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            ))}
                            <div ref={notesEndRef} />
                        </ul>
                    )}
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "4px", paddingTop: "8px" }}>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center", border: "1px solid #585aa8", borderRadius: 10, backgroundColor: "rgba(255, 255, 255, 0.87)" }}>
                        <textarea
                            placeholder="Press Enter for a new line"
                            value={noteInput}
                            // maxLength={125}
                            onChange={handleInputChange}
                            // onKeyDown={handleKeyDown}
                            style={{
                                flexGrow: 1,
                                padding: "12px",
                                border: "none",
                                backgroundColor: "transparent",
                                resize: "none",
                                height: "110px",
                                fontFamily: "inherit",
                                outline: "none",
                                boxShadow: "none",
                            }}
                        />
                        <div style={{ marginRight: 10, flexDirection: "column", display: "flex", justifyContent: "space-between", gap: 4 }}>
                            <IconButton disabled={noteInput.trim() === ""} onClick={!savingLoader ? handleSaveNote : ""} className={`${classes.iconButtonBase} ${classes.checkButton}`}>
                                {savingLoader ? <CircularProgress style={{ color: "#fff" }} size="13px" /> : <CheckIcon />}
                            </IconButton>
                            <IconButton disabled={noteInput.trim() === ""} onClick={cancelUpdate} className={`${classes.iconButtonBase} ${classes.closeButton}`}>
                                <ClearIcon />
                            </IconButton>
                        </div>
                    </div>
                    {noteError && (
                        <div style={{ color: "red", fontSize: "12px" }}>
                            {noteError}
                        </div>
                    )}
                </div>
            </div>

            <Modal size="md" show={deleteModal} onHide={(event) => cancelDelete()} backdrop='static' centered>
                <Modal.Header style={customStyle.modal_header} closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '15px' }}>
                    <div style={customStyle.HomeContainer}>
                        <div style={customStyle.HomeMAinChild}>
                            Are you sure you want to delete this note?
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <CustomButton style={{ height: '40px', marginRight: 10 }} onClick={() => confirmDelete(confirmNote)}>CONFIRM</CustomButton>
                    <CustomButton style={{ height: '40px' }} onClick={() => cancelDelete()}>CANCEL</CustomButton>
                </Modal.Footer>
            </Modal>
            <Modal size="md" show={editModal !== null} onHide={(event) => setEditModal(null)} backdrop='static' centered>
                <Modal.Header style={customStyle.modal_header} closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '15px' }}>
                    <div style={customStyle.HomeContainer}>
                        <div style={customStyle.HomeMAinChild}>
                            You will lose all changes if you edit a different note. Do you want to switch?
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <CustomButton style={{ height: '40px', marginRight: 10 }} onClick={() => confirmEdit()}>CONFIRM</CustomButton>
                    <CustomButton style={{ height: '40px' }} onClick={() => setEditModal(null)}>CANCEL</CustomButton>
                </Modal.Footer>
            </Modal>
            <Modal size="md" show={successModal} onHide={(event) => setSuccessModal(false)} backdrop='static' centered>
                <Modal.Header style={customStyle.modal_header} closeButton>
                    <Modal.Title>Message</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '15px' }}>
                    <div style={customStyle.HomeContainer}>
                        <div style={customStyle.HomeMAinChild}>
                            {errMsg}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <CustomButton style={{ height: '40px' }} onClick={() => setSuccessModal(false)}>OK</CustomButton>
                </Modal.Footer>
            </Modal>
        </Grid>
    )
}

export default Notes


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1),
        backgroundColor: '#e3edff',
        borderRadius: 16,
        width: 'fit-content',
    },
    iconButtonBase: {
        width: 36,
        height: 36,
        padding: 6,
        borderRadius: '50%',
        border: '2px solid',
        '& svg': {
            fontSize: 18,
        },
        '&.Mui-disabled': {
            backgroundColor: '#f5f5f5',
            color: '#9e9e9e',
            borderColor: '#bdbdbd',
        },
    },
    checkButton: {
        backgroundColor: '#2a2f92',
        color: '#fff',
        border: '2px solid #2a2f92',
        '&:hover': {
            backgroundColor: '#1c2170',
        }, '&.Mui-disabled': {
            backgroundColor: '#f5f5f5',
            color: '#9e9e9e',
            border: '2px solid #bdbdbd',
        },
    },
    closeButton: {
        backgroundColor: '#fff',
        color: '#2a2f92',
        border: '2px solid #2a2f92',
        '&:hover': {
            backgroundColor: '#e0e5ff',
        },
    },
}));